<template>
	<el-dialog width="45%" class="dialog" :title="title" :visible="visible" @close="closeFun">
		<el-form
			:key="operaType"
			ref="ruleForm"
			label-position="left"
			:rules="rules"
			:model="dialogForm"
			label-width="120px"
		>
			<el-form-item label="区域选择：" prop="addressKeys">
				<div class="tree">
					<el-tree
						ref="tree"
						:data="treeData"
						show-checkbox
						node-key="keyStr"
						:default-expanded-keys="expandedKeys"
						:default-checked-keys="checkedKeys"
						@check-change="checkChange"
						:props="{
							children: 'smsAddressTreeVOS',
							label: 'label',
						}"
					>
					</el-tree>
				</div>
			</el-form-item>
			<el-form-item label="回收品类：" prop="spid">
				<el-select
					v-model="dialogForm.spid"
					placeholder="请选择"
					clearable
					style="width:100%"
					@change="
						() => {
							dialogForm.xlid = ''
							dialogForm.xhid = ''
							getSpXiaolei()
						}
					"
				>
					<el-option
						v-for="item in dlList"
						:key="item.spid"
						:label="item.spmc"
						:value="item.spid"
						style="width:100%"
					>
					</el-option>
				</el-select>
			</el-form-item>
			
			<el-row type="flex">
				<el-col :span="14">
				<el-form-item prop="xlid">
					<el-select
						v-model="dialogForm.xlid"
						placeholder="请选择"
						clearable
						style="width:100%"
						:disabled="!dialogForm.spid"
						@change="
							() => {
								dialogForm.xhid = ''
								getSpModel()
							}
						"
					>
						<el-option
							v-for="item in xlList"
							:key="item.xlid"
							:label="item.xlmc"
							:value="item.xlid"
							style="width:100%"
						>
						</el-option>
					</el-select>
				</el-form-item>
				</el-col>
				<el-col :span="10">
				<el-form-item prop="xhid" label-width="auto">
					<el-select
						v-model="dialogForm.xhid"
						placeholder="请选择"
						clearable
						style="width:100%"
						:disabled="!dialogForm.xlid"
					>
						<el-option
							v-for="item in modelList"
							:key="item.xhid"
							:label="item.xhmc"
							:value="item.xhid"
							style="width:100%"
						>
						</el-option>
					</el-select>
				</el-form-item>
				</el-col>
			</el-row>

			<el-form-item label="合作方名称：" prop="partnerId">
				<el-select
					v-model="dialogForm.partnerId"
					placeholder="请选择"
					clearable
					style="width:100%"
				>
					<el-option
						v-for="item in managementOptions"
						:key="item.partnershipId"
						:label="item.partnerName"
						:value="item.partnershipId"
						style="width:100%"
					>
					</el-option>
				</el-select>
			</el-form-item>
      <el-form-item label="抽成金额：" prop="commission">
				<el-input-number
					v-model="dialogForm.commission"
					:min="0"
					:max="999999"
				></el-input-number>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button @click="closeFun">取 消</el-button>
			<el-button type="primary" :loading="btnLoading" @click="addFun"
				>确 定</el-button
			>
		</div>
	</el-dialog>
</template>
<script>
// dlList:大类, xlList: 小类, modelList: 模型, managementOptions: 合作方在mixins
import selectOptions from '../../mixins/selectOptions'
export default {
  mixins: [selectOptions],
  name: 'AddCommissionDialog',
	data() {
		return {
			title: '创建',
			operaType: 'add',
      visible: false,
			dialogForm: {
				spid: '',
				xlid: '',
				xhid: '',
				addressKeys: [],
				commission: '',
				partnerId: '',
			},
			rules: {
				addressKeys: [
					{ type: 'array', required: true, message: '请选择区域', trigger: 'change' },
				],
				spid: [{ required: true, message: '请选择回收品类', trigger: 'change' }],
				xlid: [{ required: true, message: '请选择小类', trigger: 'change' }],
				xhid: [{ required: false, message: '请选择型号', trigger: 'change' }],
				commission: [{ required: true, message: '请填写抽成金额', trigger: 'change' }],
				partnerId: [{ required: true, message: '请填写合作方名称', trigger: 'change' }],
			},
			treeData: [],
			checkedKeys: [],
			expandedKeys: [],
			btnLoading: false
		}
	},
	watch: {
		'dialogForm.spid'(value) {
			if (value) {
				this.getSpXiaolei(this.dialogForm.spid)
			}
		},
		'dialogForm.xlid'(value) {
			if (value) {
				this.getSpModel(this.dialogForm.spid, this.dialogForm.xlid)
			}
		},
	},
  methods: {
    // 区域选择改变事件
    checkChange () {
      const checkNodes = this.$refs.tree.getCheckedNodes()
      const checkedKeys = this.$refs.tree.getCheckedKeys()
			this.dialogForm.addressKeys = checkedKeys
    },
    // 打开弹框
		async opendDialog (operaType = 'add', initData) {
			this.operaType = operaType
			this.title = operaType === 'add' ? '创建' : '编辑'
			this.editId = operaType == 'edit'? initData.regionId : ''
			this.resetFormFun()
			this.getTblSplbDalei()
			this.getManagementOptions()
			this.loadAddressList()
			this.visible = true
    },
    // 关闭弹框
    closeFun () {
			this.visible = false
    },
    // 表单重置
		resetFormFun () {
			if (this.$refs.tree) {
				this.checkedKeys = []
				this.dialogForm.addressKeys = []
				this.$refs.tree.setCheckedKeys([])
			}
			if (this.$refs.ruleForm) {
				this.$refs.ruleForm.resetFields()
			}
    },
		addFun() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
					this.addDataReqFun()
        }
      })
		},
    // 获取省市区树形结构
    loadAddressList () {
      const url = '/autoapp-default-server-recovery/api/commission/platform/treeHierarchy'
			this.HttpService.get(url).then(res => {
				if (res.statusCode === 200) {
					this.treeData = res.data
					if (this.operaType == 'edit') {
						this.editGetDetailFun()
					}
				}else {
          const msgTip = res.message || '请求出错'
          this.$message.error(msgTip)
        }
			})
		},
		treeFilter(tree, func) {
      return tree.map(node => ({...node})).filter(node => {
        node.smsAddressTreeVOS = node.smsAddressTreeVOS && this.treeFilter(node.smsAddressTreeVOS, func)
        return func(node) || (node.smsAddressTreeVOS && node.smsAddressTreeVOS.length)
      })
    },
		// 添加或者编辑数据请求
		addDataReqFun () {
			let arr = this.treeFilter(this.treeData, (node)=> {
				return this.dialogForm.addressKeys.includes(node.keyStr)
			})
			const spInfo = this.dlList.find(item => item.spid === this.dialogForm.spid)
			const xlInfo = this.xlList.find(item => item.xlid === this.dialogForm.xlid)
			const modelInfo = this.modelList.find(item => item.xhid === this.dialogForm.xhid)
			const partnerInfo = this.managementOptions.find(item => item.partnershipId === this.dialogForm.partnerId)

			const params = {
				platformCommission: {
					...this.dialogForm,
					regionId: this.operaType == 'add' ? undefined : this.editId,
					spmc: spInfo ? spInfo.spmc : '',
					xlmc: xlInfo ? xlInfo.xlmc : '',
					xhmc: modelInfo ? modelInfo.xhmc : '',
					partnerName: partnerInfo ? partnerInfo.partnerName : '',
					
				},
				smsAddressTreeVOS: arr
			}
			const url = `/autoapp-default-server-recovery/api/commission/platform/save`
			this.btnLoading = true
			this.HttpService.post(url, params).then(res => {
				if (res.statusCode === 200) {
					const messageTip = this.operaType == 'add'? '创建成功' : '编辑成功'
					this.$message.success(messageTip)
					this.$emit('opera-success')
					this.closeFun()
				} else {
					const msgTip = res.message || '请求失败'
					this.$message.error(msgTip)
				}
				this.btnLoading = false
			}, err => { 
				this.btnLoading = false
			})

		},
		//遍历树结构
    treeForeach(tree, func) {
      tree.forEach(data => {
        func(data)
        data.smsAddressTreeVOS && this.treeForeach(data.smsAddressTreeVOS, func) // 遍历子树
      })
    },
		// 编辑获取详情
		editGetDetailFun () {
			const url = `/autoapp-default-server-recovery/api/commission/platform/detail?regionId=${this.editId}`
			this.HttpService.get(url).then(res => {
				if (res.statusCode === 200) {
					// console.log('==res===', res)
					const platformCommission = res.data.platformCommission
					this.dialogForm = Object.assign({}, this.dialogForm, platformCommission)
          this.treeForeach(res.data.smsAddressTreeVOS, (node) => {
            if (!node.smsAddressTreeVOS){
              this.checkedKeys.push(node.keyStr)
            }
          })
					this.$refs.tree.setCheckedKeys(this.checkedKeys)
					this.dialogForm.addressKeys = this.checkedKeys
				}else {
          const msgTip = res.message || '请求出错'
          this.$message.error(msgTip)
        }
			})
		}
	}
}
</script>
<style lang="scss">
.dialog {
	.dialog-footer {
		padding: 20px 60px;
	}
}

.tree {
	max-height: 200px;
	overflow: auto;
	border-radius: 3px;
	border: 1px solid #c0c4cc;
}
</style>



// WEBPACK FOOTER //
// src/views/commissionManage/platformCommissionSet/components/AddCommissionDialog.vue